import {Box, Flex, Skeleton, Stack} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Shared PDP main-area placeholder.
 * Used by DynamicPage (until slim mainRegion stubs), Container, and ProductDetail.
 * Gallery SCAPI (allImages:true) is fetched only on Contentful Page BasePage — do not duplicate on DynamicPage.
 */
const PdpPageSkeleton = () => (
  <Box
    className="pdp-page-skeleton__root"
    marginX="auto"
    maxWidth="1440px"
    minHeight={{base: '50vh', lg: 'auto'}}
    paddingX={{base: '20px', lg: '80px'}}
    paddingY={{base: 4, lg: 8}}
    width="100%"
  >
    <Stack className="pdp-page-skeleton__mobile" display={{base: 'flex', lg: 'none'}} spacing={4} width="100%">
      <Skeleton height="8" marginBottom={4} width="60%" />
      <Skeleton aspectRatio={25 / 12} width="100%" />
      <Skeleton height="12" width="100%" />
      <Skeleton height="12" width="100%" />
    </Stack>

    <Flex
      align="flex-start"
      className="pdp-page-skeleton__columns"
      display={{base: 'none', lg: 'flex'}}
      gap="80px"
      width="100%"
    >
      <Stack flex="1 1 65%" minWidth={0} spacing={4} width="100%">
        <Skeleton aspectRatio={25 / 12} width="100%" />
        <Skeleton height="32" width="100%" />
      </Stack>

      <Stack flex="1 1 35%" minWidth={0} spacing={3} width="100%">
        <Skeleton height="8" marginBottom={4} width="60%" />
        <Skeleton height="12" width="100%" />
        <Skeleton height="24" width="100%" />
        <Skeleton height="8" marginBottom={4} marginTop={4} width="60%" />
        <Skeleton height="24" width="100%" />
        <Skeleton height="24" width="100%" />
      </Stack>
    </Flex>
  </Box>
);

PdpPageSkeleton.displayName = 'PdpPageSkeleton';

export default PdpPageSkeleton;
